/**
 * Table component.
 * @module components/table
 */

const table = {

	$window: $(window),

	elem: {
		$user: $('.user-markup table'),
		$table: $('.table')
	},

	init() {
		if ( this.elem.$user.length > 0) {
			this.elem.$user.wrap('<div class="table"><div class="table__table"></div></div>');
			this.elem.$table = $('.table');
		}
		
		if ( this.elem.$table.length > 0) {
			$(window).on('resize', this.overscroll.bind(this));
			this.overscroll();
		}
	},

	overscroll() {
		this.elem.$table.each(function() {
			$(this).removeClass('table--overscroll');
			if($(this).find('table').width() > $(this).width()) {
				$(this).addClass('table--overscroll');
			}
		});
	}

};

export { table };
